import request from '@/utils/request';


let server = {
  authentication: '/verifications', // 实名认证
  authenticationModify: '/verifications', // 修改实名认证
  authenticationMsg: '/verifications', // 获取实名认证信息
  userInformation: '/users', // 获取登陆用户信息
  personalData: '/users', // 修改个人信息
  bindingCode: '/verification_codes', // 绑定手机邮箱验证码
  modifyCode: '/verification_codes', // 修改手机邮箱验证码
  modifyBinding: '/change_users', // 修改

};




//  实名认证
export function authentication(params) {
	return request({
    	url: server.authentication,
	    method: 'post',
	    data:params
  	})
}


//  修改实名认证
export function authenticationModify(params) {
	return request({
    	url: server.authenticationModify + '/' + params.userVerification,
	    method: 'patch',
	    data:params
  	})
}


//  获取实名认证信息
export function authenticationMsg() {
	return request({
    	url: server.authenticationMsg,
	    method: 'get',
  	})
}


//  获取登陆用户信息
export function userInformation() {
	return request({
    	url: server.userInformation,
      method: 'get'
  	})
}


//  修改个人信息
export function personalData(params) {
	return request({
    	url: server.personalData,
      method: 'patch',
      data:params
  	})
}


//  绑定手机邮箱验证码
export function bindingCode(params) {
	return request({
	  url: server.bindingCode,
      method: 'post',
      data:params
  	})
}


//  修改手机邮箱验证码
export function modifyCode(params) {
	return request({
	  url: server.modifyCode,
      method: 'post',
      data:params
  	})
}


//  修改
export function modifyBinding(params) {
	return request({
	  url: server.modifyBinding,
      method: 'PATCH',
      data:params
  	})
}










// WEBPACK FOOTER //
// ./src/api/authentication.js